module.exports = __webpack_public_path__ + "img/grey_sms.b92161ac.svg";